import { render } from "./DomainsView.vue?vue&type=template&id=5ec3c760&scoped=true"
import script from "./DomainsView.vue?vue&type=script&lang=js"
export * from "./DomainsView.vue?vue&type=script&lang=js"

import "./DomainsView.vue?vue&type=style&index=0&id=5ec3c760&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec3c760"]])

export default __exports__